exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".p-user-coupons table{font-size:.75rem}.p-user-coupons table th:nth-child(3){max-width:90px}", ""]);

// exports
